import { Component } from '@angular/core';
import { ConfigService } from 'src/app/config.service';
import { SettingsService } from 'src/app/settings/settings.service';
import { SSEService } from 'src/app/sse.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  connectionStatus = 'Verbinde zum Server...';
  serverVersion = 'x.x.x';
  version = 'x.x.x';

  constructor(private settingsService: SettingsService, private configService: ConfigService,
    public sseService: SSEService
  ) {
    this.version = this.configService.configData.appVersion;
    this.settingsService.getServerVersion().subscribe(
      version => {
        this.serverVersion = version.number;
      }
    );
    this.sseService.connectionState$.subscribe((state) => {

      switch (state) {
        case 'connected':
          this.connectionStatus = 'verbunden';
          break;
        case 'connecting':
          this.connectionStatus = 'Verbinde zum Server...';
          break;
        case 'unavailable':
          this.connectionStatus = 'Server nicht erreichbar';
          break;
        default:
          this.connectionStatus = 'unbekannt';
      }
    });
  }

}
